var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group phone-with-country-code"},[_c('VueTelInput',{attrs:{"default-country":_vm.country,"dropdown-options":{
      'showDialCodeInList':true,
      'showDialCodeInSelection':false,
      'showFlags':true,
      'showSearchBox':true,
    },"input-options":{
      'autofocus':true,
      'showDialCode':true,
      'placeholder':'+54 9 11 3288 4589',
      'required':true,
    },"mode":'international',"valid-characters-only":true},on:{"validate":_vm.validatePhoneNumber,"open":function($event){_vm.open=true},"close":function($event){_vm.open=false}},scopedSlots:_vm._u([{key:"arrow-icon",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.open ? '▲' : '▼'))])]},proxy:true}])}),_c('i',{class:_vm.userPhoneIcon,attrs:{"aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }